import { useMutation, useQueryClient } from 'react-query'
import { setAutoRenew, type SetAutoRenewPayload } from '../api/subscriptionApi'
import { PROFILE_QUERY_KEY } from '@entities/user'

/**
 * Включить/выключить автопродление подписки.
 * По успеху — инвалидация профиля, чтобы в сторе обновились `auto_renew` и `is_active`.
 */
export const useSetAutoRenewMutation = () => {
  const qc = useQueryClient()
  return useMutation<void, Error, SetAutoRenewPayload>(setAutoRenew, {
    onSuccess: () => {
      qc.invalidateQueries(PROFILE_QUERY_KEY)
      qc.invalidateQueries(['subscription'])
    },
  })
}
